import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy — Azamra</title>
        <meta name="description" content="Azamra Financial Technologies PLC privacy policy explaining how we collect, use, and safeguard your personal data." />
        <meta property="og:title" content="Privacy Policy — Azamra" />
        <meta property="og:url" content="https://www.azamra.com/privacy-policy" />
        <link rel="canonical" href="https://www.azamra.com/privacy-policy" />
      </Helmet>
      <Header />

      <section className="legal-hero-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} md={10} xs={12} className="text-center">
              <h1 className="legal-hero-title">Privacy Policy</h1>
              <p className="legal-hero-subtitle">
                How we collect, use, and protect your personal information.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="legal-content-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} md={10} xs={12}>

              <p className="legal-intro">
                Azamra Financial Technologies PLC ("Azamra", "we", "our") is committed to protecting your
                personal information. This policy explains how we collect, use, and safeguard data when
                you visit our website or interact with our digital platforms. It aligns with Cameroon's
                cybersecurity and data-protection laws and <strong>CEMAC Regulation 02/18 on personal data
                protection</strong>.
              </p>

              <div className="legal-divider" />

              <h2 className="legal-section-title">1. Information We Collect</h2>
              <p className="legal-body">We may collect:</p>
              <ul className="legal-list">
                <li>Information you provide (name, email, phone, company, messages)</li>
                <li>Technical data (IP address, device type, browser, pages visited)</li>
                <li>Cookies and analytics data</li>
                <li>Information from partners or regulatory bodies when required</li>
              </ul>

              <h2 className="legal-section-title">2. How We Use Your Information</h2>
              <p className="legal-body">We use your data to:</p>
              <ul className="legal-list">
                <li>Respond to inquiries and provide services</li>
                <li>Improve our website and user experience</li>
                <li>Manage event registrations and communications</li>
                <li>Comply with legal and regulatory obligations (BEAC, COBAC, MINFI)</li>
                <li>Ensure security and prevent fraud</li>
              </ul>
              <p className="legal-body">We <strong>do not sell</strong> your personal data.</p>

              <h2 className="legal-section-title">3. Data Sharing</h2>
              <p className="legal-body">We may share information with:</p>
              <ul className="legal-list">
                <li>Authorized Azamra staff and service providers</li>
                <li>Regulatory authorities when legally required</li>
                <li>Technology partners supporting our platform</li>
              </ul>
              <p className="legal-body">All partners must follow confidentiality and data-protection rules.</p>

              <h2 className="legal-section-title">4. Data Security</h2>
              <p className="legal-body">
                We use encryption, secure servers, and monitoring tools to protect your information.
                However, no online system is completely risk-free, and users should take precautions
                when sharing data online.
              </p>

              <h2 className="legal-section-title">5. Your Rights</h2>
              <p className="legal-body">Under Cameroon and CEMAC law, you may:</p>
              <ul className="legal-list">
                <li>Access your data</li>
                <li>Request correction or deletion</li>
                <li>Withdraw consent</li>
                <li>Object to certain processing activities</li>
              </ul>
              <p className="legal-body">
                Contact us at <strong>privacy@azamra.io</strong> to exercise your rights.
              </p>

              <h2 className="legal-section-title">6. Cookies</h2>
              <p className="legal-body">
                We use cookies to improve functionality and analyze traffic. You may disable cookies in
                your browser settings.
              </p>

              <h2 className="legal-section-title">7. External Links</h2>
              <p className="legal-body">
                Our website may contain links to third-party sites. We are not responsible for their privacy
                practices.
              </p>

              <h2 className="legal-section-title">8. Updates</h2>
              <p className="legal-body">
                We may update this policy from time to time. Changes will be posted on this page.
              </p>

              <div className="legal-divider" />

              <div className="legal-contact-block">
                <p className="legal-contact-label">Contact</p>
                <p className="legal-body">
                  <strong>Azamra Financial Technologies PLC</strong> &nbsp;|&nbsp; Email:{' '}
                  <a href="mailto:Info@azamra.com" className="legal-link">Info@azamra.com</a>
                </p>
              </div>

            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
